import { motion } from "framer-motion";
import { useLang } from "../context/LangContext";

export default function Skills() {
  const { t } = useLang();

  return (
    <section id="skills" className="py-24 md:py-32 bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground mb-3"
        >
          {t.skills.title}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-base text-muted-foreground max-w-2xl mb-14"
        >
          {t.skills.sub}
        </motion.p>

        <motion.div
          initial="initial"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            initial: {},
            visible: { transition: { staggerChildren: 0.1 } },
          }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
        >
          {t.skills.groups.map((group) => (
            <motion.div
              key={group.label}
              variants={{
                initial: { opacity: 0, y: 16 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              <h3 className="text-xs font-mono uppercase tracking-wider text-muted-foreground mb-4">
                {group.label}
              </h3>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li
                    key={item}
                    data-testid={`skill-${item.replace(/\s/g, "-").toLowerCase()}`}
                    className="text-sm text-foreground"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
